
import { computed, defineComponent } from 'vue';
import { IUploadInfo } from '@/composables/UseUpload';
import { useMainStore } from '@/store/mainStore';

export default defineComponent({
  props: {
    uploadInfo:
      {
        type: Object as () => IUploadInfo, required: true,
      },
  },
  setup(props) {
    const mainStore = useMainStore();

    const percentage = computed(() => {
      const per = ((props.uploadInfo.totalBytesUploaded / props.uploadInfo.totalBytesSize) * 100).toFixed(2);
      if (per === '100.00') {
        return '99.99';
      }
      return per;
    });

    const upload = computed(
      () => `${(props.uploadInfo.totalBytesUploaded / 1048576).toFixed(2)} Mb / ${(props.uploadInfo.totalBytesSize / 1048576).toFixed(2)} Mb`,
    );

    return {
      percentage,
      upload,
      mainStore,
    };
  },
});
